import { c as _c } from "react/compiler-runtime";
import type { DocumentViewerCard, DocumentViewerScore, TabGroupKind } from '@onefootprint/request-types/dashboard';
import ScoresCard from './scores-card';
import TabNavigation from './tab-navigation';
type LeftSidebarProps = {
  scores: DocumentViewerScore[];
  groupedCards: Record<TabGroupKind, DocumentViewerCard[]>;
  selectedTab: TabGroupKind;
  onTabChange: (tab: TabGroupKind) => void;
};
const LeftSidebar = t0 => {
  const $ = _c(9);
  const {
    scores,
    groupedCards,
    selectedTab,
    onTabChange
  } = t0;
  let t1;
  if ($[0] !== scores) {
    t1 = <ScoresCard scores={scores} />;
    $[0] = scores;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== groupedCards || $[3] !== onTabChange || $[4] !== selectedTab) {
    t2 = <TabNavigation groupedCards={groupedCards} selectedTab={selectedTab} onTabChange={onTabChange} />;
    $[2] = groupedCards;
    $[3] = onTabChange;
    $[4] = selectedTab;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col gap-4 p-2 h-full">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default LeftSidebar;